import { render, staticRenderFns } from "./object-mapper.vue?vue&type=template&id=3baf9c2e&scoped=true"
import script from "./object-mapper.vue?vue&type=script&lang=js"
export * from "./object-mapper.vue?vue&type=script&lang=js"
import style0 from "./object-mapper.vue?vue&type=style&index=0&id=3baf9c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf9c2e",
  null
  
)

export default component.exports